import styled from 'styled-components';

const Blur = styled.div`
  ${props => {
    if (props.blurred) {
      return `filter: blur(${props.radius || '10px'});`;
    }
  }}
`;

export default Blur;